import React, { useState, useMemo } from 'react';
import { Col, Input, Modal, Select, Space } from 'antd';
import { useLocation } from 'react-router-dom';
import SearchOptions from '../../../../Utils/SearchOptions';
import {
  SearchForUserCompanyDRAdd,
  SearchForUserCompanyEM,
  SearchResultForCompany,
} from '../../../../Utils/SearchResults';
import { userCompany } from '../../../../API/TT_ELD/userCompany';
import { sendEvent } from '../../../../Utils/analytics';
import { useCompaniesData } from '../../../../Hooks/TT_ELD/Companies';

const { Option } = Select;

interface AddMultiUserModalProps {
  isModalVisible: boolean;
  setIsModalVisible: (val: boolean) => void;
  refetch: () => void;
  id?: string | number;
  getCMPname?: any;
  userId?: number | string | undefined;
  companyId?: number | string | undefined;
  email: number | string | undefined;
}

const AddMultiUserModal: React.FC<AddMultiUserModalProps> = ({
  isModalVisible,
  setIsModalVisible,
  refetch,
  id,
  getCMPname,
  userId,
  companyId,
  email,
}) => {
  const [driverId, setDriverId] = useState<string | number | undefined>(userId);
  const [role, setRole] = useState<string>('support-user');
  const [currentCompanyId, setCurrentCompanyId] = useState<string | number | undefined>(
    companyId || id,
  );
  const [searchCompany, setSearchCompany] = useState('');

  const location = useLocation();
  const dispatcher = location.pathname.startsWith('/user/dispatcher');

  const { data: companiesData, isLoading: isCompaniesLoading } = useCompaniesData(searchCompany);

  console.log(companiesData);

  const handleOk = async () => {
    try {
      if (currentCompanyId && driverId) {
        await userCompany.addMultiUser(currentCompanyId, driverId, role);
        sendEvent(
          `Add Multi User UserCompany`,
          `Add Multi User UserCompany page`,
          `Modal Add Multi User ${currentCompanyId + ' ' + driverId + ' ' + role}`,
          driverId,
        );
        refetch();
      }
      setIsModalVisible(false);
    } catch (error) {
      console.error('Error while adding multi user:', error);
    }
  };

  const handleCancel = () => setIsModalVisible(false);

  const onSelectDriver = (_: any, { valId }: { valId: number | string | undefined }) => {
    if (valId) setDriverId(valId);
  };

  const ROLELIST = useMemo(
    () => [
      { label: 'Support User', value: 'support-user' },
      { label: 'Service Account', value: 'service-account' },
      { label: 'Administrator Account', value: 'administrator' },
      {
        label: 'Owner',
        value: 'owner',
        title:
          'The owner of the resource has full control over the resource, including the ability to read, write, edit, or delete it. They can also grant permission to other users.',
      },
    ],
    [],
  );

  return (
    <Modal
      title={dispatcher ? 'Add Company' : 'Add User'}
      open={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      okButtonProps={{ disabled: !(driverId && currentCompanyId && role) }}
      destroyOnClose
    >
      <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
        {/* Role select */}
        <Select defaultValue={role} onChange={(value) => setRole(value)} style={{ width: 300 }}>
          {ROLELIST.map((u) => (
            <Option key={u.value} value={u.value} title={u.title}>
              {u.label}
            </Option>
          ))}
        </Select>

        {dispatcher && <Input style={{ width: 300 }} disabled value={email} />}

        {/* Dispatcher → kompaniya search */}
        {dispatcher ? (
          <Select
            style={{ width: 300 }}
            showSearch
            placeholder="Search company..."
            loading={isCompaniesLoading}
            filterOption={false}
            onSearch={(value) => setSearchCompany(value)}
            onSelect={(value) => setCurrentCompanyId(value)}
            allowClear
          >
            {companiesData?.data?.map((company: any) => (
              <Option
                key={company.id}
                value={company.id}
                label={`${company.name || company.companyName} - ${company.usdot || ''}`}
              >
                {`${company.name || company.companyName}${
                  company.usdot ? ` - ${company.usdot}` : ''
                }`}
              </Option>
            ))}
          </Select>
        ) : (
          <>
            {/* Agar id yo‘q bo‘lsa kompaniya qidirish */}
            {!id && (
              <SearchOptions
                SearchResult={SearchResultForCompany}
                onSelect={({ valId }: { valId: number | undefined }) => setCurrentCompanyId(valId)}
                placeholder="Search by company"
              />
            )}

            {/* Agar id bor bo‘lsa, kompaniya nomini inputda ko‘rsatish */}
            {id && (
              <Col span={15}>
                <Input
                  style={{ width: 300 }}
                  disabled
                  defaultValue={getCMPname?.label}
                  placeholder={getCMPname?.label}
                />
              </Col>
            )}

            {/* User search (dispatcher bo‘lmagan holatda) */}
            <SearchOptions
              SearchResult={(query: string) => SearchForUserCompanyDRAdd(query, '')}
              onSelect={onSelectDriver}
              placeholder="Search by username"
            />
            <SearchOptions
              SearchResult={(query: string) => SearchForUserCompanyEM(query, '')}
              onSelect={onSelectDriver}
              placeholder="Search by email"
            />
          </>
        )}
      </Space>
    </Modal>
  );
};

export default AddMultiUserModal;
